import React, { useState, useEffect } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler'
import { USER_FOLLOW_REQUEST_LIST, USER_FOLLOW_REQUEST_ACCEPT, USER_FOLLOW_REQUEST_DELETE } from '../../../api/constants'
import LoaderModal from '../../../components/loaderModal'
import NoDataFound from '../../../components/noDataFound'
import { InView } from "react-intersection-observer"
import loader from '../../../assets/images/page-img/page-load-loader.gif'
//Sweet alert
import Swal from 'sweetalert2'


const FriendReqest = () => {

   const navigate = useNavigate()
   const [followRequests, setFollowRequests] = useState([])
   const [showLoader, setShowLoader] = useState(false)
   const [page, setPage] = useState(1)
   const [maxPage, setMaxPage] = useState(1)
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false)

   useEffect(() => {
      if (localStorage.getItem("uzoneAuthToken")) {
         getFollowRequestList()
      } else {
         navigate('/auth/sign-in')
      }
   }, [])

   async function getFollowRequestList() {
      try {
         setShowLoader(true)
         const res = await apiHandler(USER_FOLLOW_REQUEST_LIST, "POST", { page })
         console.log('Follow request list response:', res)
         if (res.data?.response?.status === 200) {
            // API returns data in followers.data path
            const requests = res?.data?.data?.followers?.data || []
            console.log('Follow requests data:', requests)
            setFollowRequests(requests)
            setMaxPage(res?.data?.data?.followers?.meta?.last_page || 1)
         } else {
            console.error('API Error:', res)
         }
      } catch (error) {
         console.error('Request error:', error)
      } finally {
         setShowLoader(false)
      }
   }

   async function loadMoreData() {
      if (page < maxPage && !showMoreDataLoader) {
         try {
            setShowMoreDataLoader(true)
            const nextPage = page + 1
            const res = await apiHandler(USER_FOLLOW_REQUEST_LIST, "POST", { page: nextPage })
            if (res.data?.response?.status === 200) {
               const requests = res?.data?.data?.followers?.data || []
               setFollowRequests([...followRequests, ...requests])
               setPage(nextPage)
            }
         } catch (error) {
            console.error(error)
         } finally {
            setShowMoreDataLoader(false)
         }
      }
   }

   async function acceptFollowRequest(followerId, index) {
      try {
         const res = await apiHandler(USER_FOLLOW_REQUEST_ACCEPT, "POST", {
            follower_id: followerId
         })
         if (res.data?.response?.status === 200) {
            // Remove the accepted request from the list
            const updatedRequests = followRequests.filter((_, i) => i !== index)
            setFollowRequests(updatedRequests)
            Swal.fire({
               title: 'Success',
               text: 'Follow request accepted!',
               icon: 'success',
               confirmButtonText: 'Okay'
            })
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.message || 'Failed to accept request',
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error)
         Swal.fire({
            title: 'Error',
            text: 'Something went wrong',
            icon: 'error',
            confirmButtonText: 'Okay'
         })
      }
   }

   async function deleteFollowRequest(followerId, index) {
      const swalWithBootstrapButtons = Swal.mixin({
         customClass: {
            cancelButton: 'btn btn-outline-primary btn-lg ms-2',
            confirmButton: 'btn btn-primary btn-lg',
         },
         buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
         title: 'Are you sure?',
         text: "You want to delete this follow request!",
         icon: 'warning',
         showCancelButton: true,
         cancelButtonText: 'Cancel',
         confirmButtonText: 'Yes, delete it!',
         reverseButtons: false,
         showClass: {
            popup: 'animate__animated animate__zoomIn'
         },
         hideClass: {
            popup: 'animate__animated animate__zoomOut'
         }
      }).then(async (result) => {
         if (result.isConfirmed) {
            try {
               const res = await apiHandler(USER_FOLLOW_REQUEST_DELETE, "POST", {
                  follower_id: followerId
               })
               if (res.data?.response?.status === 200) {
                  // Remove the deleted request from the list
                  const updatedRequests = followRequests.filter((_, i) => i !== index)
                  setFollowRequests(updatedRequests)
                  swalWithBootstrapButtons.fire({
                     title: 'Deleted!',
                     text: 'Follow request has been deleted.',
                     icon: 'success',
                     showClass: {
                        popup: 'animate__animated animate__zoomIn'
                     },
                     hideClass: {
                        popup: 'animate__animated animate__zoomOut'
                     }
                  })
               } else {
                  swalWithBootstrapButtons.fire({
                     title: 'Error',
                     text: res?.response?.data?.data?.message || 'Failed to delete request',
                     icon: 'error',
                     confirmButtonText: 'Okay'
                  })
               }
            } catch (error) {
               console.error(error)
               swalWithBootstrapButtons.fire({
                  title: 'Error',
                  text: 'Something went wrong',
                  icon: 'error',
                  confirmButtonText: 'Okay'
               })
            }
         }
      })
   }

   const deleteRequest = (followerId, index) => {
      deleteFollowRequest(followerId, index)
   }

   return (
      <>
         <LoaderModal show={showLoader} />
         <div id='content-page' className='content-page'>
            <Container>
               <Row>
                  <Col sm="12">
                     <Card>
                        <Card.Header className="d-flex justify-content-between">
                           <div className="header-title">
                              <h4 className="card-title">Follow Requests</h4>
                           </div>
                        </Card.Header>
                        <Card.Body>
                           {followRequests.length > 0 ? (
                              <ul className="request-list list-inline m-0 p-0">
                                 {followRequests.map((request, index) => {
                                    // Handle different response structures
                                    const user = request?.follower || request?.user || request;
                                    const userPhoto = user?.user_setting?.photo || user?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png";
                                    const userName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'Unknown User';
                                    const userSlug = user?.slug || '';
                                    const followerCount = user?.follower_count || 0;
                                    const followingCount = user?.following_count || 0;
                                    const userId = user?.id || request?.follower_id || index;
                                    
                                    return (
                                       <li key={userId} className="d-flex align-items-center justify-content-between flex-wrap mb-3">
                                          <div className="user-img img-fluid flex-shrink-0">
                                             <img 
                                                src={userPhoto} 
                                                alt="user-img" 
                                                className="rounded-circle avatar-40" 
                                             />
                                          </div>
                                          <div className="flex-grow-1 ms-3">
                                             {userSlug ? (
                                                <Link to={`/dashboard/app/friend-profile/${userSlug}`}>
                                                   <h6>{userName}</h6>
                                                </Link>
                                             ) : (
                                                <h6>{userName}</h6>
                                             )}
                                             <p className="mb-0">
                                                {followerCount} Followers · {followingCount} Following
                                             </p>
                                          </div>
                                          <div className="d-flex align-items-center mt-2 mt-md-0">
                                             <Link 
                                                to="#" 
                                                className="me-3 btn btn-primary rounded"
                                                onClick={() => acceptFollowRequest(userId, index)}
                                             >
                                                Accept
                                             </Link>
                                             <Link 
                                                to="#" 
                                                onClick={() => deleteRequest(userId, index)} 
                                                className="btn btn-secondary rounded"
                                             >
                                                Delete
                                             </Link>
                                          </div>
                                       </li>
                                    );
                                 })}
                                 {showMoreDataLoader && (
                                    <div className="col-sm-12 text-center">
                                       <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    </div>
                                 )}
                                 {page < maxPage && !showMoreDataLoader && (
                                    <InView as="li" onChange={(inView) => { if (inView) loadMoreData() }} className="d-block text-center mb-0 pb-0">
                                       <Link to="#" className="me-3 btn btn-primary" onClick={loadMoreData}>
                                          View More Requests
                                       </Link>
                                    </InView>
                                 )}
                              </ul>
                           ) : (
                              <NoDataFound />
                           )}
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </Container>
         </div>
      </>
   )
}

export default FriendReqest